// 1-bit pixel icons (inline SVG rects), ported from the stills kit. Generated: do not hand-edit the shapes.
export const ICONS = {
  map: ["...##...", "..####..", ".######.", "########", ".#.#.#.#", ".#.#.#.#", ".#.#.#.#", "########"],
  back: ["...#....", "..##....", ".#######", "########", ".#######", "..##....", "...#....", "........"],
  close: ["#......#", ".#....#.", "..#..#..", "...##...", "...##...", "..#..#..", ".#....#.", "#......#"],
  mic: ["..###...", ".#####..", ".#####..", ".#####..", ".#####..", "#.###.#.", ".#...#..", "..###...", "...#....", ".#####.."],
  star: ["...#....", "...#....", "..###...", "#######.", ".#####..", "..###...", ".##.##..", "#.....#."],
  book: ["#######.", "#.....#.", "#.###.#.", "#.....#.", "#.###.#.", "#.....#.", "#######.", ".######."],
  share: ["......##", ".....###", "....##..", "#..##...", "#.##....", "#.......", "#......#", "########"],
  pause: ["##..##..", "##..##..", "##..##..", "##..##..", "##..##..", "##..##..", "##..##..", "........"],
  check: [".......#", "......##", ".....##.", "#...##..", "##.##...", ".###....", "..#.....", "........"],
  heart: [".##.##..", "#######.", "#######.", ".#####..", "..###...", "...#...."],
  q: [".####.", "##..##", "....##", "...##.", "..##..", "......", "..##.."],
  ex: ["##", "##", "##", "##", "..", "##"],
  dots: ["##.##.##", "##.##.##"],
  anger: ["#..#.", ".##..", "#..#.", "....#"],
  pen: [".....##", "....###", "...###.", "..###..", ".###...", "##.....", "#......"],
  zz: ["####.", "..#..", ".#...", "####."],
  up: ["...##...", "..####..", ".######.", "...##...", "...##...", "...##..."],
  down: ["...##...", "...##...", "...##...", ".######.", "..####..", "...##..."],
  pin: [".####.", "######", "##..##", "######", ".####.", "..##..", "..##..", "...#.."],
  gear: ["..#..#..", ".######.", "##.##.##", ".#....#.", ".#....#.", "##.##.##", ".######.", "..#..#.."],
  sun: ["...#....", ".#...#..", "..###...", "#.###.#.", "..###...", ".#...#..", "...#....", "........"],
  moon: ["..###...", ".##.....", "##......", "##......", "##......", ".##.....", "..###...", "........"],
  sound: ["...#....", "..##..#.", "####.#..", "####.#.#", "####.#..", "..##..#.", "...#....", "........"],
  mute: ["...#....", "..##....", "####.#.#", "####..#.", "####.#.#", "..##....", "...#....", "........"],
  menu: ["########", "........", "########", "........", "########", "........", "........", "........"],
  skip: ["#...#...", "##..##..", "###.###.", "########", "###.###.", "##..##..", "#...#...", "........"],
  play: ["#.......", "###.....", "#####...", "#######.", "#####...", "###.....", "#.......", "........"],
  door: [".#####..", ".#...#..", ".#...#..", ".#..##..", ".#...#..", ".#...#..", ".#####..", "........"],
} as const;

export type IconName = keyof typeof ICONS;
